// Constants for image paths
export const mediaRoot = process.env.NEXT_PUBLIC_S3_MEDIA_ROOT;

export const IMAGES_TENANT = 'nuki-beta'; // Temporary use single tenant for the images

export const IMAGE_PATHS = {
  // intro
  INTRO: `${mediaRoot}/installation-check/icSurvey_start.png`,

  // real estate
  HOUSE: `${mediaRoot}/installation-check/icSurvey_realEstate_house.svg`,
  APARTMENT: `${mediaRoot}/installation-check/icSurvey_realEstate_apartment.svg`,

  // cylinder type
  NORDIC_ROUND: `${mediaRoot}/installation-check/icSurvey_cylinderTypeNordics_roundProfile.svg`,
  SCANDIC_OVAL: `${mediaRoot}/installation-check/icSurvey_cylinderTypeNordics_scandicOval.svg`,
  EURO: `${mediaRoot}/installation-check/icSurvey_cylinderType_euroProfile.svg`,
  SWISS: `${mediaRoot}/installation-check/icSurvey_cylinderType_swissRound.svg`,
  UK_OVAL: `${mediaRoot}/installation-check/icSurvey_cylinderType_ukOval.svg`,
  OTHER: `${mediaRoot}/installation-check/icSurvey_cylinderType_other.svg`,

  // Key/knob
  KNOB: `${mediaRoot}/installation-check/icSurvey_lockType_knob.svg`,
  KEY: `${mediaRoot}/installation-check/icSurvey_lockType_key.svg`,

  // Nordics inside
  NORDICS_KEY: `${mediaRoot}/installation-check/icSurvey_nordicsInside_key.svg`,
  THUMBTURN: `${mediaRoot}/installation-check/icSurvey_nordicsInside_thumbTurn.svg`,
  COMBINED: `${mediaRoot}/installation-check/icSurvey_nordicsInside_combined.svg`,
  NORDICS_OTHER: `${mediaRoot}/installation-check/icSurvey_nordicsInside_other.svg`,

  // Nordics latch type
  NORDICS_LATCH_TYPE: `${mediaRoot}/installation-check/icSurvey_nordicsLatchType.mp4`,

  // Door direction
  INWARDS: `${mediaRoot}/installation-check/icSurvey_doorDirection_inwards.svg`,
  OUTWARDS: `${mediaRoot}/installation-check/icSurvey_doorDirection_outwards.svg`,

  // Door distance
  DOOR_DISTANCE: `${mediaRoot}/installation-check/icSurvey_doorDistance.svg`,

  // Cylinder exchange possible
  CYLINDER_EXCHANGE_POSSIBLE: `${mediaRoot}/installation-check/icSurvey_cylinderExchangePossible.svg`,

  // Real estate usage
  RENTAL: `${mediaRoot}/installation-check/icSurvey_realEstateUsage_vacationRental.svg`,
  PRIVATE: `${mediaRoot}/installation-check/icSurvey_realEstateUsage_private.svg`,

  // Emergency feature
  EMERGENCY_CLIP: `${mediaRoot}/installation-check/icSurvey_emergencyFeature.mp4`,

  // Cylinder overlap
  CYLINDER_OVERLAP: `${mediaRoot}/installation-check/icSurvey_cylinderOverlap.svg`,

  // Key dimensions
  KEY_DIMENSIONS: `${mediaRoot}/installation-check/icSurvey_keyDimensions.svg`,

  // Cylinder inside/outside length
  CYLINDER_OUTER_LENGTH: `${mediaRoot}/installation-check/icSurvey_outsideCylinderLength.svg`,
  CYLINDER_INNER_LENGTH: `${mediaRoot}/installation-check/icSurvey_insideCylinderLength.svg`,

  BAD_COMPATIBILITY: `${mediaRoot}/installation-check/icSurvey_badCompatibility.png`,
  BAD_COMPATIBILITY_US: `${mediaRoot}/installation-check/ic_11_result_restricted_ultra_US.jpg`,

  // US
  US_SINGLE_CYLINDER: `${mediaRoot}/img/ic/IC_US_04_single.svg`,
  US_DOUBLE_CYLINDER: `${mediaRoot}/img/ic/IC_US_05_double.svg`,
  US_MORTISE_LOCK: `${mediaRoot}/img/ic/IC_US_05_mortise.svg`,
  US_OTHER: `${mediaRoot}/img/ic/IC_US_05_other.svg`,
  US_MULTIPLE_CYLINDER: `${mediaRoot}/img/ic/IC_US_06_multiple.svg`,

  PROPERTIES_UP_TO_20: `${mediaRoot}/installation-check/icSurvey_b2bProperties_upTo20.svg`,
  PROPERTIES_20_PLUS: `${mediaRoot}/installation-check/icSurvey_b2bProperties_20Plus.svg`,
  PROPERTIES_1_TO_49: `${mediaRoot}/installation-check/icSurvey_b2bProperties_1To49.svg`,
  PROPERTIES_50_PLUS: `${mediaRoot}/installation-check/icSurvey_b2bProperties_50Plus.svg`,
};

// "Happy path" -> exceeding not "Bad compatibility" yet
export const MAX_INNER_CYLINDER_LENGTH = 68;
export const MAX_OUTER_CYLINDER_LENGTH = 56;

// Exceeding considered "Bad compatibility"
export const MAX_INNER_CYLINDER_LENGTH_LIMIT = 82;
export const MAX_OUTER_CYLINDER_LENGTH_LIMIT = 85;
